<ng-container ngForm>
    <tg-file-uploader
        *ngIf="isFileReaderApiAvailable"
        (ngModelChange)="onFilesSelected($event)"
        [accept]="acceptedMimeTypesList"
        label="Add photo"
        name="listing-progress-add-photo"
        ngModel
        showLabel="false"
        showValidation="false"
    >
        <ng-content></ng-content>
    </tg-file-uploader>
    <div *ngIf="!isFileReaderApiAvailable">
        <ng-content select="[file-upload-disabled]"> </ng-content>
    </div>
</ng-container>
